import { GeoPoint } from 'app/shared/model/geo-point.model';

export interface ILocation {
  id?: number;
  street?: string | null;
  buildingNumber?: string | null;
  postalCode?: string | null;
  city?: string | null;
  stateProvince?: string | null;
  countryCode?: string | null;
  position?: GeoPoint | null;
}

export const defaultValue: Readonly<ILocation> = {};
